import { render, staticRenderFns } from "./ProlongateControlDlg.vue?vue&type=template&id=6b227013&"
import script from "./ProlongateControlDlg.vue?vue&type=script&lang=js&"
export * from "./ProlongateControlDlg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports